import themeStyle from 'styles/theme';

enum TaskPriority {
  LOW = 0,
  NORMAL = 1,
  HIGH = 2,
  URGENT = 3
}

const TaskPriorityColors = {
  low: themeStyle.palette.success.dark,
  normal: themeStyle.palette.info.dark,
  high: themeStyle.palette.warning.dark,
  urgent: themeStyle.palette.error.dark
};

enum TaskStates {
  NEW = 'new',
  ASSIGNED = 'assigned',
  PENDING_ASSIGNMENT = 'pending assignment',
  IN_PROGRESS = 'in progress',
  COMPLETED = 'completed',
  REJECTED = 'rejected'
}

export { TaskPriority, TaskPriorityColors, TaskStates };
